import {Box, CircularProgress, Link, Stack, Typography} from '@mui/material';
import React, {useCallback} from 'react';

import {GetPrivacyPolicyLinkParams} from 'domain/usecases';
import {makeGetPrivacyPolicyLink} from 'main/factories/usecases';
import ANSLogo from 'presentation/assets/images/ans-logo.webp';
import {GlobalExternalLinkEnum} from 'presentation/constants';
import {useGetEndpointUrl, useHostName} from 'presentation/hooks';
import {useExternalServiceStore} from 'presentation/pages/private/store/externalSerivceUrlStore';
import {translations} from 'presentation/translations-new';
import {StyledFooterContainer} from './styles';
import {FooterMobileProps} from './types';

const {allRightsReserved, privacyPolicy} = translations['pt-br'].commons;

export function FooterMobile({hideANS, hidePolicy, isLoading}: FooterMobileProps) {
	const {dataHostNameState} = useHostName();
	const {ansLogo, footerProductName} = dataHostNameState;

	const formattedFooterName = `${footerProductName} - ${allRightsReserved}`;

	const {getLink} = useGetEndpointUrl(privacyPolicy);
	const cachedURL = useExternalServiceStore(state => state.urls[privacyPolicy]);
	const {
		dataHostNameState: {productCode},
		isNotredameSaude,
	} = useHostName();

	const handleClick = useCallback(() => {
		if (cachedURL) {
			window.open(cachedURL);
			return;
		}
		const cdEmpresaPlano = productCode?.[0] || 0;
		const params: GetPrivacyPolicyLinkParams = {cdEmpresaPlano, isPpo: isNotredameSaude};
		getLink(makeGetPrivacyPolicyLink, false, false, params);
	}, [cachedURL]);

	return (
		<StyledFooterContainer>
			<Stack direction="row" justifyContent="space-between" gap={2}>
				<Stack gap={1} justifyContent="center">
					{hideANS ? null : <Box>{ansLogo({height: 16})}</Box>}
					<Typography variant="body2" color="text.secondary">
						{formattedFooterName}
					</Typography>
					{hidePolicy ? null : (
						<Stack direction="row" gap={1} alignItems="center">
							<Link
								onClick={handleClick}
								variant="body2"
								fontWeight={600}
								sx={{cursor: 'pointer'}}>
								{privacyPolicy}
							</Link>
							{isLoading ? <CircularProgress size={16} /> : null}
						</Stack>
					)}
				</Stack>

				<a href={GlobalExternalLinkEnum.ANS} target="_blank" rel="noopener noreferrer">
					<img src={ANSLogo} alt="Logo ANS" />
				</a>
			</Stack>
		</StyledFooterContainer>
	);
}
